import React from 'react';

// Voice choice for Emit-based apps (the Chaplain app). Same voices and samples as SAFE.
const VoiceChoiceModal = ({ isOpen, onClose, voices, choice, onChoose, onPreview, voiceOn, onToggleVoice, theme }) => {
  if (!isOpen) return null;
  const c = (theme && theme.colors) || {};
  const ink = c.primary || '#1f2a44';
  const mark = c.accent || '#c9a86a';
  const list = Array.isArray(voices) ? voices : [];
  return (
    <div role="dialog" aria-modal="true" aria-labelledby="voice-choice-title" onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(10,15,30,0.62)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: '16px' }}>
      <div onClick={(e) => e.stopPropagation()}
        style={{ background: '#ffffff', color: ink, borderRadius: '16px', width: '100%', maxWidth: '460px', maxHeight: '86vh', overflowY: 'auto', padding: '24px', boxShadow: '0 12px 40px rgba(0,0,0,0.35)' }}>
        <h2 id="voice-choice-title" style={{ margin: 0, fontSize: '21px', fontWeight: 700 }}>Choose a voice</h2>
        <p style={{ margin: '6px 0 18px', fontSize: '15px', lineHeight: 1.45, color: '#4a5568' }}>
          This is the voice your coach uses when replies are read aloud. Tap Play to hear each one.
        </p>

        {list.length === 0 ? (
          <p style={{ fontSize: '16px', lineHeight: 1.5, color: '#4a5568' }}>
            Voices are not available right now. Your device voice will be used.
          </p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {list.map((v) => {
              const on = v.id === choice;
              return (
                <div key={v.id}
                  style={{ display: 'flex', alignItems: 'center', gap: '10px', border: '2px solid ' + (on ? mark : '#e2e8f0'), background: on ? 'rgba(201,168,106,0.12)' : '#ffffff', borderRadius: '12px', padding: '10px 10px 10px 14px' }}>
                  <button type="button" aria-pressed={on} onClick={() => onChoose(v.id)}
                    style={{ flex: 1, textAlign: 'left', background: 'transparent', border: 'none', padding: '4px 0', cursor: 'pointer', color: ink, minHeight: '44px' }}>
                    <span style={{ display: 'block', fontSize: '17px', fontWeight: 700 }}>{on ? '\u2713 ' : ''}{v.label}</span>
                    {v.note && <span style={{ display: 'block', fontSize: '15px', color: '#4a5568', marginTop: '3px', lineHeight: 1.4 }}>{v.note}</span>}
                  </button>
                  <button type="button" onClick={() => onPreview(v.id)} aria-label={'Play a sample of ' + v.label}
                    style={{ flexShrink: 0, minHeight: '44px', minWidth: '72px', padding: '0 14px', borderRadius: '10px', border: '1.5px solid ' + ink, background: '#ffffff', color: ink, fontSize: '15px', fontWeight: 600, cursor: 'pointer' }}>
                    {'\u25B6'} Play
                  </button>
                </div>
              );
            })}
          </div>
        )}

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', marginTop: '20px', paddingTop: '16px', borderTop: '1px solid #e2e8f0' }}>
          <span style={{ fontSize: '16px', fontWeight: 600 }}>Read replies aloud</span>
          <button type="button" role="switch" aria-checked={!!voiceOn} onClick={onToggleVoice}
            style={{ minHeight: '44px', minWidth: '76px', borderRadius: '22px', border: 'none', background: voiceOn ? ink : '#cbd5e0', color: voiceOn ? '#ffffff' : '#1a202c', fontSize: '15px', fontWeight: 700, cursor: 'pointer' }}>
            {voiceOn ? 'On' : 'Off'}
          </button>
        </div>

        <button type="button" onClick={onClose}
          style={{ width: '100%', minHeight: '48px', marginTop: '18px', borderRadius: '12px', border: 'none', background: ink, color: '#ffffff', fontSize: '16px', fontWeight: 700, cursor: 'pointer' }}>
          Done
        </button>
      </div>
    </div>
  );
};

export default VoiceChoiceModal;
